export function idsNovosIfood(eventos: any[]): Set<string> {
  return new Set(
    eventos
      .filter(evento => evento.code === "PLC" && evento.pedido?.orderIdIfood)
      .map(evento => String(evento.pedido.orderIdIfood))
  );
}

export function eventosIfoodComImpressao(eventos: any[], impressaoHabilitada: boolean): any[] {
  return impressaoHabilitada
    ? eventos.filter(evento => evento.code === "PLC" && evento.pedido?.dataCupom)
    : [];
}

export function pksNovosIfood(eventos: any[]): Set<string> {
  return new Set(
    eventos
      .filter(evento => evento.code === "PLC" && evento.pedido?.pk)
      .map(evento => String(evento.pedido.pk))
  );
}

export function pedidoJaImpressoPeloIfood(pedido: any, idsIfood: Set<string>): boolean {
  return Boolean(pedido?.pedidoIfood && idsIfood.has(String(pedido.orderIdIfood)));
}

export function deveConfirmar99Food(pedido: any, pollingUnificado: boolean, integrado99FoodLegado: boolean): boolean {
  return Boolean(pedido?.pedido99Food && pedido.orderId99Food && (pollingUnificado || integrado99FoodLegado));
}
